import { render, staticRenderFns } from "./HistoryPage.vue?vue&type=template&id=ac0340fc&"
import script from "./HistoryPage.vue?vue&type=script&lang=js&"
export * from "./HistoryPage.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPage.vue?vue&type=style&index=0&id=ac0340fc&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports